/**
 * Team member modals.
 *
 * Native <dialog> + showModal(), which gives Esc-to-close, focus trapping and
 * inert background for free. It also renders in the top layer, so unlike the
 * Bootstrap modal it replaced, it is unaffected by the stacking context of the
 * page content wrapper and does not need relocating to <body>.
 */
(function () {
    const scrollLock = (locked) => {
        document.documentElement.style.overflow = locked ? 'hidden' : '';
    };

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-team-member-modal]');

        if (trigger) {
            const dialog = document.getElementById(trigger.getAttribute('data-team-member-modal'));

            if (dialog && typeof dialog.showModal === 'function') {
                dialog.showModal();
                scrollLock(true);
            }

            return;
        }

        if (event.target.closest('[data-team-member-modal-close]')) {
            event.target.closest('dialog').close();
            return;
        }

        // A click landing on the dialog element itself is a click on its ::backdrop —
        // the panel's own content sits in the child wrapper.
        if (event.target.tagName === 'DIALOG') {
            event.target.close();
        }
    });

    // `close` doesn't bubble, so listen in the capture phase. This catches Esc too.
    document.addEventListener('close', (event) => {
        if (event.target.tagName === 'DIALOG') {
            scrollLock(false);
        }
    }, true);
}());
